import { PROJECT_SERVICE } from "../consts";

export const ATTACHMENT_API = `${PROJECT_SERVICE}file-uploads`;